<template>
    <nav class="navigation">
        <div class="container">
            <div class="row row-cols-5">
                <div class="col">
                    <router-link class="nav__btn " exact-active-class="nav__btn--active" to="/store">
                        <svg class="icon"><use xlink:href="/img/icon-sprite.svg#cart"></use></svg>
                    </router-link>
                </div>

                <div class="col">
                    <router-link to="/chat" :class="{'nav__btn--active': chatIsActive}" exact-active-class="nav__btn--active" class="nav__btn">
                        <span v-if="unreadChats" class="count">{{ unreadChats }}</span>
                        <svg class="icon"><use xlink:href="/img/icon-sprite.svg#bubble"></use></svg>
                    </router-link>
                </div>

                <div class="col pl--0 pr--0">
                    <router-link :class="{'nav__btn': true, 'nav__btn--logo': true}" exact-active-class="nav__btn--active" to="/">
                        <span>
                            <img src="/img/logo.png" alt=""/>
                        </span>
                    </router-link>
                </div>

                <div class="col">
                    <router-link class="nav__btn" exact-active-class="nav__btn--active" to="/notifications">
                        <span v-if="unreadNotificationsNumber" class="count">{{ unreadNotificationsNumber }}</span>
                        <svg class="icon"><use xlink:href="/img/icon-sprite.svg#bell"></use></svg>
                    </router-link>
                </div>

                <div class="col">
                    <router-link class="nav__btn" exact-active-class="nav__btn--active" to="/profile">
                        <svg class="icon"><use xlink:href="/img/icon-sprite.svg#user"></use></svg>
                    </router-link>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters('auth', [
                'isLoggedIn',
                'unreadChats',
                'notifications'
            ]),

            unreadNotificationsNumber() {
                return collect(this.notifications).filter((item) => ! item.read_at).count()
            },

            chatIsActive() {
                return this.$router.currentRoute.path === '/chat-messages'
                    || this.$router.currentRoute.path === '/chat'
            },

            newGameIsActive() {
                return this.$router.currentRoute.path === '/new-game/multiplayer'
            }
        }
    }
</script>
